import TransactionDetailReceipt from 'components/receipt/transactions/TransactionDetailReceipt'
import {connect} from 'react-redux'
import {
  showResendEmailModal,
  showRefundBreakdownModal,
  showOldRefundModal
} from 'actions/reports/transactions'
import {Popover, OverlayTrigger} from 'react-bootstrap'
import styles from './TransactionDetail.css'
import {isFullSiteMode} from 'utils/fullSite'

class TransactionDetail extends React.Component {
  render () {
    let {transactionDetail} = this.props.data.reports.transactions

    const popover = (
      <Popover id='refundCardTransaction' placement='bottom'>Card transaction can only be refunded from the mobile device</Popover>
    )

    return (transactionDetail != null &&
      <div className={styles['receipt-box']}>
        {/* -- TOP ACTION BOX -- */}
        <div className={!isFullSiteMode() ? styles['action-box-top'] : styles['action-box-top-full-site']}>
          <button className='btn btn-default' onClick={this._onClickResendReceipt}>Resend Receipt</button>
          {transactionDetail.refundable && transactionDetail.payment_type !== 'card' && <button className='btn btn-default pull-right'
            onClick={(this._isRefundBreakdown()) ? (this._onClickIssueRefund) : (this._onClickOldIssueRefund)}>
            Issue Refund
          </button>}
          {transactionDetail.refundable && transactionDetail.payment_type === 'card' && <OverlayTrigger overlay={popover}>
            <button type='button' className='btn btn-default pull-right'>Issue Refund</button>
          </OverlayTrigger>}
        </div>
        {/* -- END TOP ACTION BOX -- */}
        {/* -- RECEIPT CONTENT -- */}
        <div className={!isFullSiteMode() ? `${styles['receipt-container']} receipt-container-custom` : `${styles['receipt-container-full-site']} receipt-container-custom`}>
          <TransactionDetailReceipt paymentDetail={transactionDetail} />
        </div>
        {/* -- END RECEIPT CONTENT -- */}
        {/* -- BOTTOM ACTION BOX -- */}
        <div className={!isFullSiteMode() ? styles['action-box-bottom'] : styles['action-box-bottom-full-site']}>
          <button className='btn btn-primary pull-right' onClick={this._onClickDoneButton}>Done</button>
        </div>
        {/* - END BOTTOM ACTION BOX -- */}
      </div>)
  }

  _onClickDoneButton = () => {
    this.props.onClickDoneButton()
  }

  _onClickResendReceipt = () => {
    this.props.dispatch(showResendEmailModal())
  }

  _onClickIssueRefund = () => {
    this.props.dispatch(showRefundBreakdownModal())
  }

  _onClickOldIssueRefund = () => {
    this.props.dispatch(showOldRefundModal())
  }

  /**
   * Determine whether the transaction detail can be refunded with refund breakdown
   * @return boolean
   * @private
   */
  _isRefundBreakdown = () => {
    let {transactionDetail} = this.props.data.reports.transactions
    if (transactionDetail.payment_refunds && transactionDetail.payment_refunds.length > 0) {
      let hasOldRefund = false
      transactionDetail.payment_refunds.forEach((refund) => {
        if (!refund.is_refund_breakdown) {
          hasOldRefund = true
        }
      })
      return !hasOldRefund
    } else {
      return transactionDetail.refund_availability.length > 0
    }
  }
}

let mapStateToProps = (state) => {
  return {
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  }
}

TransactionDetail.propTypes = {
  onClickDoneButton: React.PropTypes.func,
  dispatch: React.PropTypes.func
}

export default connect(mapStateToProps)(TransactionDetail)



// WEBPACK FOOTER //
// ./app/components/receipt/transactions/TransactionDetail/TransactionDetail.js